import React from "react";
import Main from "./components/Main";

const App = () => <Main />;

export default App;
